import React from 'react';

import { useUsStateSelectFieldQuery as useBaseQuery } from 'generated/graphql';
import _ from 'lodash';



export function useUSStateSelectField() {
  const tuple = useBaseQuery();

  return React.useMemo(() => {
    return {
      ...tuple,
      data: {
        enumValues: _.map(tuple.data?.usStates ?? [], ia => ({
          id: ia.id,
          name: ia.displayName,
          displayName: ia.displayName
        }))
      }
    };
  }, [tuple]);
}
